export const locationResultsConstants = {
  GET_CASUAL_RESULTS_REQUEST: 'GET_CASUAL_RESULTS_REQUEST',
  GET_CASUAL_RESULTS_SUCCESS: 'GET_CASUAL_RESULTS_SUCCESS',
  GET_CASUAL_RESULTS_ERROR: 'GET_CASUAL_RESULTS_ERROR',
  DELETE_RESULT_REQUEST: 'DELETE_RESULT_REQUEST',
  DELETE_RESULT_SUCCESS: 'DELETE_RESULT_SUCCESS',
  DELETE_RESULT_ERROR: 'DELETE_RESULT_ERROR',
};
